/**
 * @author Andrés Ferreira
 * @Copyright (c) Infotrack. All rights reserved.
 */
import manejadorRest from '@infotrack/presentacion-utilitarios/manejadorRest';
import { IRespuesta } from '@infotrack/presentacion-transversales/interfacesComunes';
import { negocioConfiguracion } from '../../conexiones';
import IDivisionesTiposPropiedades from './entidades/divisionesTiposPropiedades';

export default class ModeloDivisionesTiposPropiedades {
    public consultarDivisionesTiposPropiedades() {
        return manejadorRest<IRespuesta<IDivisionesTiposPropiedades>>(() =>
            negocioConfiguracion.get('DivisionTipoPropiedad/ConsultarListaDivisionTipoPropiedad')
        );
    }
    public crearDivisionesTiposPropiedades(divisionesTiposPropiedades: IDivisionesTiposPropiedades) {
        return manejadorRest<IRespuesta<IDivisionesTiposPropiedades>>(() =>
            negocioConfiguracion.post('DivisionTipoPropiedad/GuardarDivisionTipoPropiedad', divisionesTiposPropiedades)
        );
    }
    public editarDivisionesTiposPropiedades(divisionesTiposPropiedades: IDivisionesTiposPropiedades) {
        return manejadorRest<IRespuesta<IDivisionesTiposPropiedades>>(() =>
            negocioConfiguracion.put('DivisionTipoPropiedad/EditarDivisionTipoPropiedad', divisionesTiposPropiedades)
        );
    }
    public eliminarDivisionesTiposPropiedades(divisionesTiposPropiedades: IDivisionesTiposPropiedades) {
        return manejadorRest<IRespuesta<IDivisionesTiposPropiedades>>(() =>
            negocioConfiguracion.delete('DivisionTipoPropiedad/EliminarDivisionTipoPropiedad', divisionesTiposPropiedades)
        );
    }

    public consultarPorFiltroDivisionesTiposPropiedades(divisionesTiposPropiedades: Partial<IDivisionesTiposPropiedades>) {
        return manejadorRest<IRespuesta<IDivisionesTiposPropiedades>>(() =>
            negocioConfiguracion.post('DivisionTipoPropiedad/ConsultarDivisionTipoPropiedadPorFiltro', divisionesTiposPropiedades)
        );
    }
}
